import instance from "../../../api";
import {GetMenusRes} from "../types";

export const getMenuList = async ():Promise<GetMenusRes> => {
  return await instance(true)
    .get("core/commons/read-menu/")
    .then(res => res?.data);
};